import { fiveMinutes } from 'queries/constants';
import { datasourceQueryKeys } from 'queries/queryKeys/datasourceKeys';
import { useQuery } from 'react-query';
import { GetPluginFolders } from 'services/PluginService';

export const usePluginDashboardList = (pluginId: string, configId: string) => {
    return useQuery(datasourceQueryKeys.dashboardFolders(configId), () => GetPluginFolders(pluginId!, configId), {
        enabled: Boolean(pluginId),
        staleTime: fiveMinutes,
        cacheTime: fiveMinutes,
        keepPreviousData: true,
        refetchInterval: fiveMinutes
    });
};
